import { useState } from "react";
import { loginUser } from "../../api";
import { BRAND_ASSETS } from "../../brandAssets";
import "./LoginPage.css";

function LoginPage({ onLogin, onBack }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (event) => {
    event.preventDefault();
    setSubmitting(true);
    setError("");

    try {
      const user = await loginUser({ email, password });
      onLogin(user);
    } catch (err) {
      setError(err.response?.data?.detail || "Unable to sign in");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <main className="login-shell">
      <section className="login-panel" aria-label="Sign in">
        <div className="login-brand">
          <div className="login-brand-lockup">
            <img className="login-brand-logo" src={BRAND_ASSETS.logoWhite} alt="HopeCounts" />
            <strong>Suicide Prevention Dashboard</strong>
            <p>
              Surveillance and decision support system
            </p>
          </div>
        </div>

        <form className="login-form" onSubmit={handleSubmit}>
          {onBack && (
            <button type="button" className="login-back-button" onClick={onBack}>
              Back to dashboard
            </button>
          )}
          <div className="login-form-header">
            <span className="login-form-kicker">Authorized users only</span>
            <h1>Sign in</h1>
          </div>

          <label>
            Email
            <input
              type="email"
              value={email}
              onChange={(event) => setEmail(event.target.value)}
              autoComplete="email"
              required
            />
          </label>

          <label>
            Password
            <input
              type="password"
              value={password}
              onChange={(event) => setPassword(event.target.value)}
              autoComplete="current-password"
              required
            />
          </label>

          {error && <div className="login-error">{error}</div>}

          <button type="submit" disabled={submitting}>
            {submitting ? "Signing in..." : "Sign in"}
          </button>
        </form>
      </section>
    </main>
  );
}

export default LoginPage;
